export default __webpack_public_path__ + "static/media/elektron-tasbeh.1796a891.png";